__turbopack_context__.v({
  "content": "styles-module__tdmaOq__content",
  "wrapper": "styles-module__tdmaOq__wrapper",
});
